//Proofed

export const testimonial_ChrisMurray = {
    name: 'Chris Murray',
    timeAgo: '3 months ago',
    quote: 'I\'m using Contract Finder Pro on the Pro membership and have been very impressed with the platform. It\'s easy to use and offers excellent value, with a huge amount of useful information available in one place. The competitor and market intelligence features are particularly strong, being able to see what competitors have won, which frameworks and DPS they\'re on and who buyers are awarding contracts to is extremely valuable for bid professionals and businesses. Having access to supplier results, awards, buyers, frameworks and DPS data all within a single platform is fantastic and saves a significant amount of time compared to gathering this information from multiple sources. I would highly recommend Contract Finder Pro to anyone involved in public-sector bidding.',
};

export const testimonial_Anonymous1 = {
    name: 'Anonymous',
    timeAgo: '7 months ago',
    quote: 'Lianne has been fantastic in supporting our journey of trialing and subscribing to Contract Finder Pro. She answered all of our questions promptly and professionally and found a way to make the service work for us. Much appreciated',
};

export const testimonial_Anonymous2 = {
    name: 'Anonymous',
    timeAgo: '9 months ago',
    quote: 'Highly recommend Contract Finder Pro to anyone who wants to make searching for opportunities easy. I now receive simple, easy to assess opportunities every morning with a weekly roundup of contract awards. Competitor analysis and understanding your interested markets is also made simple through the portal. Sandy was very helpful throughout my initial trial period and his knowledge and experience had me up and running in no time. Great customer service and a great product.',
};

export const testimonial_Jamie = {
    name: 'Jamie',
    location: 'London, United Kingdom',
    timeAgo: 'a year ago',
    quote: 'Been using Contract Finder Pro for a few years and found it easy to navigate. Particularly like having the ability to carry out regional and competitor analysis. Recently wanted a refresher on what the platform now offers and was impressed how quickly Lianne understood what I needed and explained it clearly and thoroughly.',
};

export const testimonial_Anonymous3 = {
    name: 'Anonymous',
    location: 'Trowbridge, United Kingdom',
    timeAgo: 'a year ago',
    quote: 'Excellent product and great service - many thanks for your help!!',
};

export const testimonial_JoDawson = {
    name: 'Jo Dawson',
    location: 'Birmingham, United Kingdom',
    timeAgo: 'a year ago',
    quote: 'Excellent service offering value for money, with responsive support. Does exactly what we need and more.',
};

export const testimonial_Cameron = {
    name: 'Cameron',
    timeAgo: 'a year ago',
    quote: 'CFP is a fantastic tool that much easier to use than competitors. Lianne was extremely helpful and took time to understand our use case in detail to be as effective as possible. Highly recommend!',
};

export const testimonial_Anonymous4 = {
    name: 'Anonymous',
    timeAgo: 'a year ago',
    quote: 'Lianne was very helpful and Contract Pro Finder were very flexible and understanding to our needs. The system is very informative, with daily alerts set to the CPV codes and competitor analysis was particularly useful to making an informed decision on whether the system was suitable for our needs.',
};

export const testimonial_Phil = {
    name: 'Phil',
    location: 'Glasgow, United Kingdom',
    timeAgo: 'a year ago',
    quote: 'A really useful tool and super easy to use. Their representative, Lianne, was incredibly helpful and knowledgeable. I would recommend this tool and the additional pro features (such as market analysis) for anyone serious about exploring and having success with tenders.',
};

export const testimonial_JennBeeston = {
    name: 'Jenn Beeston',
    timeAgo: '2 years ago',
    quote: 'Fantastic service!',
};

export const testimonial_Anonymous5 = {
    name: 'Anonymous',
    timeAgo: '2 years ago',
    quote: 'I really appreciated the high level of professionalism of the Contract Finder Pro customer support team. I particularly thought it was admirable to see the warnings from the company in regard to my subscription trial ending. It\'s such a refreshing change from the usual approach of \'hopefully they won\'t remember\'.',
};

export const testimonial_George = {
    name: 'George',
    timeAgo: '2 years ago',
    quote: 'This does exactly what it says on the tin. The UI is really accessible and easy to use. The tender tracking functionality is excellent - and Lianne is really great at helping you refine your search terms. Some of the \'pro\' features are excellent, in particular the Framework Tracker and ability to carry out detailed competitor and buyer analysis. The regular email updates on new tenders, awards, etc, are just what we need. Bake in the great customer service and extremely competitive price point and I\'d definitely recommend.',
};

export const testimonial_ColinLedsom = {
    name: 'Colin Ledsom',
    timeAgo: '2 years ago',
    quote: 'Firstly and vital to the success of CFP, Lianne is simply great. Very helpful, knowledgeable and keen to make you get the most out of Contract Finder Pro. I found the system a real benefit to the business and developing a stronger forecast/pipeline.',
};

export const testimonial_MartynBell = {
    name: 'Martyn Bell',
    timeAgo: '2 years ago',
    quote: 'Lianne was so helpful all the way through the process of introducing the platform through to going live - the platform trial was so user friendly and gave all the information needed. I thoroughly recommend contract finder.',
};

export const testimonial_AmandaGreenwood = {
    name: 'Amanda Greenwood',
    timeAgo: '',
    quote: 'Really simple and intuitive structure, can search terms easily. Also appreciate the helpful summaries of opportunities which give just enough detail to allow you to scan and get an overview without trawling through. My favourite bit is the weekly digest of successful awards, great for understanding the competitor landscape!',
};

export const testimonial_Jessica = {
    name: 'Jessica',
    timeAgo: '2 years ago',
    quote: 'A huge time-saver to receive notifications of relevant potential projects. Excellent customer service, focused on our company needs.',
};

export const testimonial_KathyTaylor = {
    name: 'Kathy Taylor',
    timeAgo: '2 years ago',
    quote: 'Huge timesaver for me with all the leads consolidated into one email so I am no spending my time doing individual portal searches. Loved the buyer and competitor insight as well - very useful.',
};

export const testimonial_Kate = {
    name: 'Kate',
    timeAgo: '2 years ago',
    quote: 'I\'ve found CFP has given me visibility of contracts and tenders I would not usually see. As a small company, this is invaluable for building business. The daily email alert is particularly useful. Thank you :)',
};

export const testimonial_FayDavies = {
    name: 'Fay Davies',
    timeAgo: '2 years ago',
    quote: 'We have found CFP very beneficial for our business and good value for money. It is easy to use and the (simple to set up) automated email alerts for Award Notifications and New Opportunities help maximise the benefits of the system. Support from the CFP team has also been excellent.',
};

export const testimonial_Anonymous6 = {
    name: 'Anonymous',
    timeAgo: '2 years ago',
    quote: 'I\'ve been using CFP for a few years now and have found it to be very useful, easy to use and accessible, with great customer service available from the team whenever we\'ve needed it. Over those years I\'ve grown my team and have added a number of extra CFP licences - it really is an integral part of our business winning process.',
};

export const testimonial_DavidD = {
    name: 'David D',
    timeAgo: '3 years ago',
    quote: 'Contract Finder Pro helps me find, track and use the information I need quickly and effectively.',
};

export const testimonial_Louis = {
    name: 'Louis',
    timeAgo: '3 years ago',
    quote: 'I have found Contract Finder Pro very easy to use. The customer service is fantastic. They are always there on hand to help me if I get stuck on my search terms. It has made my working life a lot easier.',
};

export const testimonial_LeeMuscroft = {
    name: 'Lee Muscroft',
    timeAgo: '3 years ago',
    quote: 'I met Lianne and we had a great meeting. I signed up for the services there and then. I\'m still learning how to use it but can\'t believe how many business opportunities there are out there. Once again a big thank you.',
};

export const testimonial_Elle = {
    name: 'Elle',
    timeAgo: '3 years ago',
    quote: 'As an Australian business looking to work with government in the UK, this site has been invaluable for understanding the opportunities out there. It\'s so great to get peace of mind that all tenders can be found here. The insights and data tools are fab, especially the historic data. Very easy to use and set up. The team are super friendly and went above and beyond to help us navigate the UK market.',
};

export const testimonial_Sanjeev = {
    name: 'Sanjeev',
    timeAgo: '3 years ago',
    quote: 'I have been trialing the Contracts Finder Pro for a while now and the system is good for what you need. Lianne had kindly offered me a free trial (without inputting credit card). Throughout the process Lianne has been helpful, professional and answered my queries in a timely manner. Overall very good service.',
};

export const testimonial_Aitor = {
    name: 'Aitor',
    timeAgo: '3 years ago',
    quote: 'I found what I was looking for and really helpful and personalised customer service! Thanks, gracias!',
};

export const testimonial_Jas = {
    name: 'Jas',
    timeAgo: '3 years ago',
    quote: 'Useful service which saves time and effort. Lianne Mosley our account manager has been helpful.',
};

export const testimonial_AdamB = {
    name: 'Adam B',
    timeAgo: '3 years ago',
    quote: 'Lianne was very helpful from start to finish. Helped us understand how to use the portal to find contracts. She also provided us with a contact to point us in the right direction for help with submitting tenders. If you have no idea where to start with tenders, like us, then this is the place to come to.',
};

export const testimonial_Ann = {
    name: 'Ann',
    timeAgo: '4 years ago',
    quote: 'I really value what Contract Finder Pro offers in terms of identifying tenders that match your service offering in a very efficient and effective way. It is completely user-friendly and ensures no tender opportunities are missed.',
};

export const testimonial_JonS = {
    name: 'Jon S',
    timeAgo: '',
    quote: 'Powerful search with everything in one place, good for historical searching too. Plus the guys helped us out at a difficult time to ensure we could still get the benefit of the system.',
};

export const testimonial_Jamie3 = {
    name: 'Jamie',
    timeAgo: '4 years ago',
    quote: 'I\'ve used a range of tender tracking and market and competitor intelligence solutions previously... Contract Finder Pro isn\'t only better in every respect (it has been designed top to bottom with the needs of sales and bid professionals in mind), it offers exceptional value for money, too. Their team is also extraordinarily receptive to client feedback, iteratively enhancing their service all the time -- I can\'t recommend them highly enough!',
};

export const testimonial_JennyMcGuckin = {
    name: 'Jenny McGuckin',
    timeAgo: '4 years ago',
    quote: 'Really easy to use system and the response we get when we require help is fantastic',
};

export const testimonial_MarcDawson = {
    name: 'Marc Dawson',
    timeAgo: '4 years ago',
    quote: 'Its a very efficient and effective way in which to identify tenders which match your service offering. Support is also great in terms of how to maximise the search output through key word inputs etc. Would recommend.',
};

export const testimonial_DrSimonBenham = {
    name: 'Dr. Simon Benham',
    timeAgo: '4 years ago',
    quote: 'Contract Finder Pro has already become an important tool for our Sales and BD team after only a couple of months. It is very easy to use and competitively priced. We use it to continually receive opportunities and contract award notifications that we were previously unaware of. This has enabled us to expand and bid into new markets. We have also started using other features such as customer spending analysis. I highly recommend it.',
};

export const testimonial_DebraSamuel = {
    name: 'Debra Samuel',
    timeAgo: '5 years ago',
    quote: 'I recently signed up for the free trial and while the product is not suitable for my business, the customer service is second to none. Lianne is an excellent ambassador for the company and guides you through the product with skill. I will definitely be recommending Contract Finder Pro to my network.',
};

export const testimonial_AllChange = {
    name: 'AllChange Strategic Consulting',
    timeAgo: '5 years ago',
    quote: 'Since signing up to Contract Finder Pro, we have found this a \'must-have service\' and a key part of the sales/tender mix. My team and I have found this a great tool that materially contributes to our market research and analysis - generating real actionable insight. I could not recommend this enough!',
};

export const testimonial_RupertCooke = {
    name: 'Rupert Cooke',
    timeAgo: '5 years ago',
    quote: 'Excellent customer service from the fabulous Lianne who held my hand (virtually) throughout the whole set up process. Already pitched for our first tender!',
};

export const testimonial_WarringtonYouthClub = {
    name: 'Warrington Youth Club',
    timeAgo: '5 years ago',
    quote: 'As a charity, having every procurement opportunity in one place is perfect and a real time-saver! Liane has been incredibly helpful in getting us set up and is always available to answer questions and give support. The site is very user-friendly and it\'s really simple to tailor searches and set up email alerts so we never miss opportunities.',
};

export const testimonial_BhuJohal = {
    name: 'Bhu Johal',
    timeAgo: '5 years ago',
    quote: 'After trialling other services nothing could compare to Contract Finder Pro. It is so easy to use and covers a wide range of opportunities. What makes this even better is the friendly staff that are always there on hand to help. Definitely would recommend Contract Finder Pro',
};

export const testimonial_Rachel = {
    name: 'Rachel',
    timeAgo: '5 years ago',
    quote: 'Great customer service and easy to use website. I would highly recommend.',
};

export const testimonial_StephanieRockall = {
    name: 'Stephanie Rockall',
    timeAgo: '5 years ago',
    quote: 'Excellent service and really easy to work with. I would definitely recommend!',
};

export const testimonial_Stephanie = {
    name: 'Stephanie',
    timeAgo: '5 years ago',
    quote: 'Contract Finder Pro, Where do I start! They were great from the start, I enquired about a demo and I was shown the way from that point. They explained everything in detail and ensured I knew what I was doing with the platform. They helped me set up my keywords and CPV codes so that the relevant tenders came through to me. When I have had questions they have always been more than happy to help. They are extremely cheap for the service they provide! Thank you Contract Finder Pro, I will continue to use your service to push my business forward',
};

export const testimonial_Alexis = {
    name: 'Alexis',
    timeAgo: '5 years ago',
    quote: 'CFP have helped me get set up, with a great website that has given me visibility of a huge body of relevant government tenders with only a few mouse-clicks. This, combined with their customer service, quality personnel (shout out to Sandy) and extremely competitive pricing means they are an obvious choice for anybody looking contract for HMG.',
};

export const testimonial_MarkHolland = {
    name: 'Mark Holland',
    timeAgo: '5 years ago',
    quote: 'Clear and easy to use - responsive and delivers the information in a clear format. Equally important with any of these services is that when you raise a concern or an improvement, that they are able to consider and act on it. Thanks!',
};

export const testimonial_KyleJameson = {
    name: 'Kyle Jameson',
    timeAgo: '',
    quote: 'We were extremely pleased with the service and outcomes provided by Contract Finder Pro. We have found numerous suitable tender opportunities for us and have since been awarded our first public contract. Thank you very much to the team!',
};

export const testimonial_Liz = {
    name: 'Liz',
    timeAgo: '6 years ago',
    quote: 'Was given very attentive and useful advice on how to make the most of CFP',
};

export const testimonial_Laura = {
    name: 'Laura',
    timeAgo: '6 years ago',
    quote: 'Easy to use and great value - I found some good contracts. Great customer service too!',
};

export const testimonial_MattMercer = {
    name: 'Matt Mercer',
    timeAgo: '6 years ago',
    quote: 'A supremely effective and efficient service. CFP delivers on every level and has fast become a vital part of my working day. Essential for anyone working in procurement across the few public sector, I couldn\'t recommend it any higher.',
};

export const testimonial_Sophie = {
    name: 'Sophie',
    timeAgo: '6 years ago',
    quote: 'Contract Finder Pro was extremely helpful in finding us work after lockdown closed off some of our normal markets. The website is easy to navigate and the service is friendly and efficient. I would highly recommend Contract Finder Pro.',
};

export const testimonial_Graham = {
    name: 'Graham',
    timeAgo: '6 years ago',
    quote: 'Easy to use with a powerful search function that not only shows open tenders, but allows a search of awarded contracts as well. A significant improvement over other tendering websites.',
};

export const testimonial_CherylKennedy = {
    name: 'Cheryl Kennedy',
    timeAgo: '6 years ago',
    quote: 'I\'ve found the guys at ContractFinderPro very helpful. They listened to how I was wanting to grow my business and they talked me through how to use their tender database in order for me to gain the most benefits. I am impressed with their professionalism and knowledge. I think their system is going to be very useful.',
};

export const testimonial_EmmyOsman = {
    name: 'Emmy Osman',
    timeAgo: '7 years ago',
    quote: 'I used CFP to do some research on whether I could grow my business into the public sector, having been almost exclusively commercially focused until now. I wasn\'t really sure where to start, but the team were really helpful, showing me how to search and what things to look out for! Saved me so much time and really helped me focus on what opportunities were right for me. Thank-you so much!',
};

export const testimonials = [
    testimonial_ChrisMurray,
    testimonial_AmandaGreenwood,
    testimonial_KathyTaylor,
    testimonial_Jamie,
    testimonial_Kate,
    testimonial_JoDawson,
    testimonial_Cameron,
    testimonial_George,
    testimonial_ColinLedsom,
    testimonial_MartynBell,
];

export const coreTestimonials = [
    testimonial_KathyTaylor,
    testimonial_AmandaGreenwood,
    testimonial_George
]

export const analyticsTestimonials = [
    testimonial_Jamie,
    testimonial_ChrisMurray,
    testimonial_KathyTaylor
]

